import { useQuery } from '@tanstack/react-query'

import {
  retrieveStream,
  type StreamingSessionDetail,
} from '@/features/yakureki'

// 録音中の Chirp finals / interim を 2s 間隔で polling. finalize 後 (status='finalized'/'failed') で停止.
// MeetingBlock 経由で state==='recording' / 'stopping' のときに enabled になる.
// interim は final 到着で null クリアされる揮発値のため、 poll 間隔が粗いと italic 表示がほぼ
// 拾えない. nasu-patient-app-front の live transcript poll と同じ 2s に揃える.
const DEFAULT_INTERVAL_MS = 2_000

interface Options {
  sessionId: string | null
  enabled?: boolean
  intervalMs?: number
}

const isStreamTerminal = (
  data: StreamingSessionDetail | undefined
): boolean => {
  if (!data) return false
  return data.status === 'finalized' || data.status === 'failed'
}

export const usePollStreamingTranscript = ({
  sessionId,
  enabled = true,
  intervalMs = DEFAULT_INTERVAL_MS,
}: Options) =>
  useQuery({
    queryKey: ['streamingSession', sessionId, 'poll'],
    queryFn: () => retrieveStream(sessionId!),
    enabled: enabled && !!sessionId,
    refetchInterval: (query) => {
      if (isStreamTerminal(query.state.data)) return false
      return intervalMs
    },
    refetchIntervalInBackground: true,
    staleTime: 0,
  })
